/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React from "react";
import PropTypes from "prop-types";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import { isRangeSetting, isEnumSetting } from "../../utils/isRangeEnumSetting";
import RangeSetting from "../setting-type/rangeSetting";
import EnumSetting from "../setting-type/enumSetting";

export default function ImageSettings(props) {
  const { imageSettings, handleSettingModified } = props;
  return Object.keys(imageSettings).map((key, index) => {
    const setting = imageSettings[key];
    if (isEnumSetting(setting) && setting.AllowedValues.length > 0) {
      return (
        <Box sx={{ mt: 1 }} key={`${index}-enum`}>
          <EnumSetting name={key} setting={setting} handleSettingModified={handleSettingModified}/>
          <Divider />
        </Box>
      );
    }
    if (isRangeSetting(setting) && setting.Max !== "" && setting.Min !== "") {
      return (
        <Box sx={{ mt: 1 }} key={`${index}-range`}>
          <RangeSetting name={key} setting={setting} handleSettingModified={handleSettingModified}/>
          <Divider />
        </Box>
      );
    }
  });
}

ImageSettings.propTypes = {
  imageSettings: PropTypes.shape({}).isRequired,
  handleSettingModified: PropTypes.func.isRequired,
};
